import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import { RxCrossCircled } from "react-icons/rx";
export const PromotionalModal = ({
  show,
  onHide,
  setOffer,
  offer,
  dataOffer,
}) => {
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return "Ended";
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `End in ${days} days ${hours} hours`;
  }
  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Body
        style={{
          height: "400px",
          overflowY: "scroll",
          padding: "15px",
          background: "#141515",
          paddingRight: "0",
          borderRadius: "5px",
          position: "relative",
          scrollbarWidth:"none",
          paddingRight:"15px"
        }}
      >
        <div
          style={{
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            marginBottom: "13px",
            fontSize: "15px",
          }}
        >
          Promotional Offers{" "}
          <RxCrossCircled size={20} color="white" onClick={() => onHide()} />
        </div>

        <div>
          {dataOffer?.map((res) => {
            return (
              <div
                onClick={() => {
                  setOffer(res?._id);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#222424",
                  color: "white",
                  padding: "10px",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  border: res?._id == offer ? "3px solid #14805e" : "none",
                }}
                className="radio-block"
              >
                <div className="radio-block__body">
                  <div className="promotion-item__content">
                    {" "}
                    <div
                      style={{ fontSize: "16px" }}
                      className="promotion-item__descrp ng-tns-c334385074-81"
                    >
                      {res?.title}
                    </div>
                    <div style={{ fontSize: "10px" }}>{res?.description}</div>
                    <div
                      style={{ fontSize: "11px", color: "#657381" }}
                      className="promotion-item__title ng-tns-c334385074-81"
                    >
                      {getTimeDifferenceString(
                        new Date(),
                        res?.offerEndDateTime
                      )}
                    </div>
                    <div
                      style={{ fontSize: "11px", color: "#657381" }}
                      className="promotion-item__date ng-tns-c334385074-81"
                    >
                      {moment(res?.offerStartDateTime).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}{" "}
                      -
                      {moment(res?.offerEndDateTime).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}
                    </div>
                  </div>
                </div>{" "}
                <input
                  style={{ accentColor: " #14805e" }}
                  type="radio"
                  checked={res?._id == offer}
                />
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
};
